import React from 'react'
import HeroImage from '../assets/images/coaching-1.png';
import Shield from '../assets/icons/Shield.svg';
import StarBadge from '../assets/icons/starBadge.svg';
import Lock from '../assets/icons/Lock.svg'
import Vector from '../assets/images/HeroVector.svg'
import { CalendarIcon, MapPinIcon } from '@heroicons/react/24/solid';
export default function Hero() {
  
  return (
    <div id="home" className="flex container-padding gap-12 xl:gap-32 items-center relative pb-10 overflow-hidden scroll-m24">
      {/* HeroVector */}
      <div className="absolute left-0 -top-24 h-full z-20">
        <img src={Vector} className="h-full"></img>
      </div>

      <div className="flex flex-col gap-4 w-full md:w-7/12 z-20 items-center md:items-start mt-24 lg:mt-0">
        <h1 className="whitespace-nowrap">SelectFut Camp</h1>
        <p className="text-center md:text-left">
        SelectFut Camp offers a holistic approach to player development by providing technical, tactical 
          training while establishing a love for the game of soccer. 
        </p>
        
        <div className="flex flex-col items-center lg:items-start lg:flex-row justify-start gap-5 w-full">
          <div className="flex items-center gap-3">
            <CalendarIcon className="text-white w-6"/>
            <p>Dec 27, &lsquo;23 - Dec 29, &lsquo;23</p>
          </div>
          <div className="flex items-center gap-3">
            <MapPinIcon className="text-white w-6"/>
            <p>1220 River Rd, New Castle, DE 19720</p>
          </div>

        </div>
        <div className="mb-10 flex gap-10 items-center">
          <a className="btn-primary px-16 py-3 rounded-full" href="#pricing">Register</a>
          <a href="#details">Learn More &rarr;</a>
        </div>
        <h3>Why Us?</h3>
        <div className="flex gap-3 w-full lg:w-3/4">
          <div className="flex flex-col items-center card w-1/3 gap-3 px-2 py-4">
            <img src={Shield} alt="trusted-coaches" className="h-10"/>
            <p className="text-center">Coaches you can trust</p>
          </div>
          <div className="flex flex-col items-center card w-1/3 gap-3 px-2 py-4">
            <img src={StarBadge} alt="trusted-coaches" className="h-10"/>
            <p className="text-center">Proffessional experience</p>
          </div>
          <div className="flex flex-col items-center card w-1/3 gap-3 px-2 py-4">
            <img src={Lock} alt="trusted-coaches" className="h-10"/>
            <p className="text-center">Easy Booking and Payment</p>
          </div>
        </div>
      </div>

      {/* Ellipse */}
      <div className="absolute left-0 -top-10 h-full">
        <div className="relative h-full">
          <div className="ellipse z-10"></div>
        </div>
      </div>
      
      <div className="hidden md:flex md:w-5/12 z-20 flex-col gap-4">
        <img src={HeroImage} className="object-contain"/>
        <div className="flex gap-4 items-center">
          <p className="text-sm w-2/3">Learn from a coaching staff of professional soccer players.</p>
          <a className="btn-secondary w-1/3 text-sm rounded-md py-1 text-center" href="#staff">Our Staff <span>&rarr;</span></a>
        </div>
      </div>
      <div className="polygon z-10"></div>
    </div>
  )
}
